import { Map } from 'immutable';
import { records } from '@saucelabs/sl-module-user';

import * as types from './types';


const initialState = Map({
  loading: true,
  user: new records.UserRecord(),
});

const usersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.INITIALIZE:
      return state.set('loading', false);
    case types.USER_GET.REQUEST:
      return state.set('loading', true);
    case types.USER_GET.SUCCESS:
      return state.set('user', new records.UserRecord(payload));
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default usersReducer;
export { initialState };
